<template>
  <el-container class="safety-monitor-container">
    <!-- 左侧菜单 -->
    <el-aside class="sidebar">
      <!-- 修正原代码的el-saide拼写错误 -->
      <div class="menu-group">
        <div class="menu-title">作业行为检测</div>
        <div
          v-for="item in behaviorMenu"
          :key="item.key"
          :class="['menu-item', { active: activeMenu === item.key }]"
          @click="activeMenu = item.key"
        >
          {{ item.label }}
        </div>
      </div>
      <div class="menu-group">
        <div class="menu-title">作业安全检测</div>
        <div
          v-for="item in safetyMenu"
          :key="item.key"
          :class="['menu-item', { active: activeMenu === item.key }]"
          @click="activeMenu = item.key"
        >
          {{ item.label }}
        </div>
      </div>
    </el-aside>

    <!-- 右侧内容区 -->
    <el-main class="content">
      <!-- 顶部筛选栏 -->
      <div class="filter-bar">
        <el-select
          placeholder="请选择监控区域"
          style="width: 180px; margin-right: 16px"
          class="dark-select"
        />
        <el-select
          placeholder="请选择摄像头"
          style="width: 180px; margin-right: 16px"
          class="dark-select"
        />
        <el-select
          placeholder="请选择处理状态"
          style="width: 180px; margin-right: 16px"
          class="dark-select"
        />
        <!-- <el-date-picker
          type="datetimerange"
          range-separator="~"
          start-placeholder="报警开始时间"
          end-placeholder="报警结束时间"
          style="width: 420px; margin-right: 16px"
          class="dark-datepicker"
        /> -->
        <el-button type="primary" style="margin-right: 8px">查询</el-button>
        <el-button type="info">重置</el-button>
      </div>

      <!-- 操作栏 -->
      <div class="action-bar">
        <div>
          <el-button type="primary" size="small" style="margin-right: 8px"
            >批量处理</el-button
          >
          <el-button type="primary" size="small">导出</el-button>
        </div>
        <el-button type="primary" size="small " @click="handleCreate"
          >检测任务管理</el-button
        >
      </div>

      <!-- 数据表格 -->
      <el-table :data="tableData" style="width: 100%" class="dark-table">
        <el-table-column type="selection" width="50" />
        <el-table-column prop="scene" label="现场画面" width="120">
          <template #default="scope">
            <div class="scene-placeholder">
              <el-icon><Picture /></el-icon>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="alarmContent" label="报警内容">
          <template #default="scope"> {{ activelabe }} </template>
        </el-table-column>
        <el-table-column prop="alarmVideo" label="报警视频" width="100">
          <template #default="scope">
            <el-button type="text" size="small">
              <el-icon><VideoPlay /></el-icon>
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="monitorPoint" label="监控点" />
        <el-table-column prop="alarmArea" label="报警区域" />
        <el-table-column prop="alarmTime" label="报警时间" width="180" />
        <el-table-column prop="status" label="处理状态" width="120">
          <template #default="scope">
            <el-tag
              v-if="scope.row.status === '未处理'"
              type="danger"
              effect="dark"
              >未处理</el-tag
            >
            <el-tag v-else type="primary" effect="dark">已处理</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template #default="scope">
            <el-button type="text" size="small">
              <el-icon><View /></el-icon>
            </el-button>
            <el-button type="text" size="small">
              <el-icon><Download /></el-icon>
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <!-- <div class="pagination-wrapper">
        <el-pagination
          v-model:current-page="currentPage"
          v-model:page-size="pageSize"
          :page-sizes="[20, 50, 100]"
          :total="total"
          layout="total, prev, pager, next, sizes, jumper"
          class="dark-pagination"
        />
      </div> -->
    </el-main>
  </el-container>
  <setTask ref="setTaskRef" />
</template>

<script setup>
import { ref, reactive, computed } from "vue";
import { Picture, VideoPlay, View, Download } from "@element-plus/icons-vue";
import setTask from "./dialog/setTask.vue";
const setTaskRef = ref(null);
const handleCreate = () => {
  setTaskRef.value.openDialog();
};
// 左侧菜单
const behaviorMenu = [
  { key: "helmet", label: "安全帽检测" },
  { key: "uniform", label: "工作服检测" },
  { key: "rope", label: "安全绳检测" },
  { key: "shoes", label: "踩踏装置管线检测" },
  { key: "sleep", label: "睡觉检测" },
  { key: "leave", label: "离岗检测" },
  { key: "phone", label: "打电话检测" },
  { key: "smoke", label: "抽烟检测" },
  { key: "gather", label: "玩手机检测" },
  { key: "personStay", label: "人员逗留检测" },
  // { key: "carStay", label: "车辆逗留检测" },
  // { key: "climb", label: "攀高检测" },
  // { key: "hoistStand", label: "吊物站人检测" },
  // { key: "pipeStand", label: "管道站人检测" },
  // { key: "intrusion", label: "非法入侵检测" },
  { key: "guardianLeave", label: "监护人离岗" },
];

const safetyMenu = [
  { key: "flame", label: "佩戴面屏检测" },
  { key: "smoke11", label: "防酸碱服检测" },
  { key: "oilLeak", label: "佩戴防静电手环检测" },
  { key: "cylinderRelease", label: "安全喊话检测" },
  { key: "cylinderRelease1", label: "佩戴面罩及绝缘手套检测" },
  { key: "cylinderRelease12", label: "穿戴防护服及绝缘手套检测" },
];

const activeMenu = ref("rope"); // 默认选中安全绳检测
const activelabe = computed(() => {
  const list = [...behaviorMenu, ...safetyMenu];
  return list.find((item) => item.key === activeMenu.value)?.label;
});
// 表格数据
// const tableData = reactive(
//   Array.from({ length: 8 }).map(() => ({
//     scene: "",
//     alarmContent: "安全绳不规范",
//     alarmVideo: "",
//     monitorPoint: "IPC32",
//     alarmArea: "中国石油",
//     alarmTime: "2025/12/02 19:33:02",
//     status: "未处理",
//   })),
// );
const tableData = computed(() => {
  // 从1-8中随机娶一个整数
  const randomIndex = Math.floor(Math.random() * 8) + 1;
  // 获取当前时间
  const currentTime = new Date();
  const year = currentTime.getFullYear();
  const month = currentTime.getMonth() + 1;
  const day = currentTime.getDate();
  const hour = currentTime.getHours();
  const minute = currentTime.getMinutes();
  const second = currentTime.getSeconds();
  const alarmTime = `${year}/${month}/${day} ${hour}:${minute}:${second}`;
  return Array.from({ length: randomIndex }).map(() => ({
    scene: "",
    alarmContent: activelabe.value,
    alarmVideo: "",
    monitorPoint: ["IPC32", "IPC34", "IPC35"][Math.floor(Math.random() * 2)],
    alarmArea: "中国石油",
    alarmTime: alarmTime,
    status: ["已处理", "未处理"][Math.floor(Math.random() * 2)],
  }));
});

// 分页
const currentPage = ref(1);
const pageSize = ref(20);
const total = ref(940);
</script>

<style scoped>
/* 整体容器 - 深色背景 */
.safety-monitor-container {
  display: flex;
  height: 100%;
  background-color: #141414; /* 深色主背景 */
  color: #e5e5e5; /* 浅色文字 */
}

/* 左侧侧边栏 - 深色风格 */
.sidebar {
  width: 200px;
  background-color: #011132; /* 侧边栏深色背景 */
  border-right: 1px solid #333; /* 深色边框 */
  overflow-y: auto;
}

.menu-group {
  margin-bottom: 20px;
}

/* 菜单标题 - 深灰底色 + 浅灰文字 */
.menu-title {
  padding: 12px 16px;
  font-size: 14px;
  color: #b0b0b0; /* 浅灰色文字 */
  background-color: #010e5a; /* 深灰色背景 */
}

/* 菜单项 - 深色底色 */
.menu-item {
  padding: 12px 16px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.menu-item:hover {
  background-color: #333; /* 悬浮深色 */
}

.menu-item.active {
  background-color: #1890ff; /* 选中保留蓝色 */
  color: #fff;
}

/* 右侧内容区 - 深色背景 */
.content {
  flex: 1;
  padding: 16px;
  overflow-y: auto;
  background-color: #011132;
  margin: 0px 8px;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.3); /* 深色阴影提升层次感 */
}

/* 筛选栏和操作栏 */
.filter-bar {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.action-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

/* 现场画面占位符 - 深色风格 */
.scene-placeholder {
  width: 80px;
  height: 60px;
  background-color: #292929; /* 深色占位 */
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  color: #b0b0b0;
}

/* 分页容器 */
.pagination-wrapper {
  margin-top: 16px;
  text-align: right;
}

/* 深色表单组件样式 */
.dark-select :deep(.el-select__wrapper) {
  background-color: #011132;
  border-color: #444;
  color: #e5e5e5;
}
.dark-select :deep(.el-select__placeholder) {
  color: #b0b0b0;
}

.dark-datepicker :deep(.el-date-editor) {
  background-color: #292929;
  border-color: #444;
}
.dark-datepicker :deep(.el-input__inner) {
  color: #e5e5e5;
}
.dark-datepicker :deep(.el-input__placeholder) {
  color: #b0b0b0;
}

/* 深色标签样式 */
.dark-tag {
  --el-tag-text-color: #fff;
  --el-tag-bg-color: #d9363e;
  --el-tag-border-color: #d9363e;
}

.dark-table :deep(.el-table__header-wrapper th) {
  background-color: rgba(0, 34, 102, 0.8) !important;
  color: #e5e5e5 !important;
}

.dark-table :deep(.el-table__row) {
  background-color: rgba(1, 17, 50, 0.9) !important;
  color: #fff;
}
.el-table {
  --el-table-border-color: #444 !important;
}
</style>
